import FullPageErrorDefault from './FullPageError';

export default FullPageErrorDefault;



// WEBPACK FOOTER //
// ./src/client/Components/FullPageError/index.js